import React, { useEffect, useState } from "react";
import styles from "./UserItem.module.scss";
import { useFetch } from "hooks/useFetch";
import { userEndpoints } from "hooks/endpoints";
import { isEmpty } from "lodash";

const UserItem = ({
  user,
  handleDelete,
  type = "member",
  isSelected,
  onSelect,
}) => {
  const [localSelected, setLocalSelected] = useState(isSelected);
  const { data: userImage, refetch: refetchImage } = useFetch(
    ["userImage", user?.userId],
    userEndpoints.getUserImage(user?.userId),
    {
      enabled: false,
    }
  );

  useEffect(() => {
    if (!isEmpty(user)) {
      refetchImage();
    }
  }, [user]);

  const handleToggleSelect = () => {
    const newSelected = !localSelected;
    setLocalSelected(newSelected);
    onSelect(user.userId);
  };

  return (
    <div className={styles["user-item-container"]}>
      <div className={styles["image-container"]}>
        <img
          src={
            !isEmpty(userImage?.data?.result?.imageBytes)
              ? `data:image/jpeg;base64,${userImage?.data?.result?.imageBytes}`
              : "/images/user-empty.svg"
          }
          width="60"
          height="60"
          alt={user?.username}
          className={styles["user-image"]}
        />
        <span>
          {"member" === type
            ? user?.userName
            : `${user?.firstName} ${user?.lastName}`}
        </span>
      </div>
      {"member" === type ? (
        <img
          src="/images/remove.svg"
          className={styles["add-remove-image"]}
          onClick={() => handleDelete(user?.userId)}
          height={20}
          width={20}
        />
      ) : (
        <img
          src={localSelected ? "/images/remove.svg" : "/images/add.svg"}
          className={styles["add-remove-image"]}
          onClick={handleToggleSelect}
          height={20}
          width={20}
          alt={localSelected ? "Remove" : "Add"}
        />
      )}
    </div>
  );
};

export default UserItem;
